import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, FormControl, ValidatorFn, NgForm, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalPromptComponent } from '../../../../_helpers/Modals/prompt/modal.prompt';
import { Constants } from '../../../../_utils/Constants';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { LoginComponent } from '../login/login.component';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import * as crypto from 'crypto-js';
import { $BroadcastManagerService } from '../../../../_helpers/BroadcastManager.service';
import { APIConstants } from '../../../../_config/restapis';
import { formatDate } from '@angular/common';
import { MustMatch } from '../../../../_helpers/must-match-validator';
import { FileSelectDirective, FileUploader } from 'ng2-file-upload';
import * as CryptoJS from 'crypto-js';
import { ModalPromptEntityComponent } from '../../../../_helpers/Modals/prompt-entity/modal.prompt-entity';
import { Subscription, interval } from 'rxjs';


export interface industrycategorylist {
  value: string;
  viewValue: string;
}
export interface telelist {
  value: string;
  viewValue: string;
}
export interface industrylist {
  value: string;
  viewValue: string;
}
export interface sectorlist {
  value: string;
  viewValue: string;
}
export interface selectedCountry {
  id: string;
  name: string;
}

export interface selectedState {
  id: string;
  name: string;
  country_id: string
}
export interface selectedCity {
  id: string;
  name: string;
  state_id: string;
}
export interface poalist {
  value: string;
  viewValue: string;
}
export interface sectorlist2 {
  value: string;
  viewValue: string;
}

export interface indListItems {
  value: string;
  viewValue: string;
}

export interface nonGovSectorListItem {
  value: string;
  viewValue: string;
}

export interface poilistitems {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-entity-kyc-renewal-process',
  templateUrl: './entity-kyc-renewal-process.component.html',
  styleUrls: ['./entity-kyc-renewal-process.component.css']
})

export class EntityKycRenewalProcessComponent implements OnInit {
  response: any
  Entity_Ref_No: any
  TM_Type: any
  entityId: any
  Common_ID: any
  peRegistered: boolean = false
  tmRegistered: boolean = false
  taRegistered: boolean = false
  dltFlag: boolean = false

  selectedPE: boolean = false
  selectedTM: boolean = false
  selectedTA: boolean = false
  regEclass: any

  radiocheckshow: boolean = false
  peChecked: boolean = false
  tmChecked: boolean = false
  taChecked: boolean = false
  peFlag: boolean = true
  tmFlag: boolean = true
  taFlag: boolean = true
  public ishide: boolean = false;
  public otpinfo: boolean = false;
  public addrinfo: boolean = false;
  public ishidecontinue: boolean = false;
  public isReadonly: boolean = false;
  public subscription: Subscription;

  showSEBI: boolean;
  public modalRef: BsModalRef;
  returnedValue: any;
  gstidinfo: any;
  gstDoc: boolean;
  listdiv: boolean;

  Entity_POI_Doc: any;
  Entity_POA_Doc: any
  Entity_SEBI_Doc: any
  Entity_GST_Doc: any
  Entity_POAZ_Doc: any;
  Entity_POAZID_Doc: any
  Entity_Other_Doc: any
  Entity_Other_Doc1: any
  poilistitems: any = []
  indListItems: any = []
  oldDocs: any[] = []

  otpEmail: any
  otpEExp: any
  otpMobile: any
  otpMExp: any
  regEmail: any
  regMobile: any
  isEmailMod: boolean = false
  isMobileMod: boolean = false
  public isDisabledbtn: boolean = true;

  otherindtypeshow: boolean = false
  othersectorshow: boolean = false
  industryCategory: any
  Registered_Operator: any
  Registered_ID: any
  myfileotherDuplicate: any = []



  modify_count: any;
  expirationdate: Date = new Date;
  showalert: boolean = false;
  daysRemaining: number;

  constructor(private fb: FormBuilder,
    private modalService: BsModalService,
    private es: APIEntityService,
    private db: $DBManagerService,
    private $modal: $ModalManagerService,
    private _route: ActivatedRoute,
    private router: Router) {

    this.entityId = this.db.get(Constants.SESSSION_STORAGE, Constants.ENTITY_ID);
  }

  entityForm: FormGroup;
  selectedValue: String;
  telelist: any;
  industrylist: any;
  sectorlist: any;
  selectedCountryId: any;
  selectedStateId: any;
  newlistitems: any = [];
  newstatelistitems: any = [];
  pantanno: any;
  address1: any;
  allowedExtensions: any;
  fileExtension: any;
  fileExtensionError: boolean = false
  myfiles: any[] = [];
  //uploadPOI: string[];
  photoName: any;
  fileSizeError1: boolean = false
  fileSizeError2: boolean = false
  public showOTPfields: boolean = false
  fileExtensionMessage: any;
  photoContent: any;
  PANshow: boolean = false
  TANshow: boolean = false
  isSEBI: boolean = false
  emailVerify: boolean = false
  mobileVerify: boolean = false
  selectpoi: any;
  selectedpoi: string;
  poalist: any;
  public poashowone: boolean = false
  public poashowtwo: boolean = false
  public poashowthree: boolean = false
  selectpoa: any;
  public teledroplist: boolean = false
  public govtlistdiv: boolean = false
  public selectedcatpan: boolean = false
  public selectedcatpantan: boolean = false
  public selectedtan: boolean = false
  public showpoaselect: boolean = false
  public showpoitype: boolean = false
  isNumCheckadres1: boolean = false;
  isNumCheckadres2: boolean = false;
  isNumOrgName: boolean = false;
  public poifileExtensionError: boolean = false
  public poafileExtensionError: boolean = false
  public poazfileExtensionError: boolean = false
  public poazidfileExtensionError: boolean = false
  public sebifileExtensionError: boolean = false
  public gstfileExtensionError: boolean = false
  public otherfileExtensionError: boolean = false
  public disableEotp: boolean = false;
  public disableMotp: boolean = false;

  fileuploadpoiMax: boolean = false
  fileuploadpoiMin: boolean = false
  fileuploadpoaMax: boolean = false
  fileuploadpoaMin: boolean = false
  fileuploadpoazMax: boolean = false
  fileuploadpoazMin: boolean = false
  fileuploadpoazidMax: boolean = false
  fileuploadpoazidMin: boolean = false
  fileuploadsebiMax: boolean = false
  fileuploadsebiMin: boolean = false
  fileuploadgstMax: boolean = false
  fileuploadgstMin: boolean = false
  fileuploadotherMax: boolean = false
  fileuploadotherMin: boolean = false
  isemailMobileReadonly: boolean = false;



  confirmgstid: any;
  public email: any;
  public mobileno: any;
  public Hash_KYC_Doc: any;
  public Hash_KYC_Doc1: any;
  public Hash_KYC_Doc2: any;
  public Hash_KYC_Doc3: any;
  public Hash_KYC_Doc4: any;
  public Hash_KYC_Doc5: any;
  public Hash_KYC_Doc6: any;
  public Hash_KYC_Doc7: any;


  public showRemainingFields: boolean = false
  public showverifyOTP: boolean = false

  myfilepoi: any[] = [];
  myfilepoa: any[] = [];
  myfilepoaz: any[] = [];
  myfilepoazid: any[] = [];
  myfilesebi: any[] = [];
  myfilegst: any[] = [];
  myfileother: any[] = [];

  registerNewClas: boolean = false;
  modifyOtherDet: boolean = false;
  modifyOtherDetRemove: boolean = false;
  TATrue: boolean = false;
  PETrue: boolean = false;
  TMTrue: boolean = false;
  RegisterNewCalrificationbtn: boolean = true;
  StatusC: boolean = false;
  StatusP: boolean = false;
  StatusCRegister: boolean = true;
  StatusCProfile: boolean = false;
  changeEmailMobile: boolean = false
  entityCreatorAddress: boolean = false;

  // to verify the address change on submit and popup POA
  addr1: any;
  addr2: any;
  landmk: any;
  country: any;
  city: any;
  pincd: any;
  state: any;
  docchanged: boolean = false;

  expiryDiffDays: any;
  hasPasswordExpired: boolean;

  get f() { return this.entityForm.controls; }

  industrycategorylistitems: industrycategorylist[] = [
    { value: 'G', viewValue: 'Government' },
    { value: 'P', viewValue: 'Private Ltd Company' },
    { value: 'S', viewValue: 'SEBI' },
    { value: 'U', viewValue: 'Public Limited Company' },
    { value: 'O1', viewValue: 'Individual' },
    { value: 'O2', viewValue: 'Sole Proprietorship' },
    { value: 'O3', viewValue: 'Partnership Firm' },
    { value: 'O4', viewValue: 'Limited Liability Partnership' },
    { value: 'O5', viewValue: 'Trust, Association, Society, Club' },
    { value: 'O', viewValue: 'Others' },
  ];

  telelistitems: telelist[] = [
    { value: 'Scrubbing Service & Delivery Function', viewValue: 'Scrubbing Service & Delivery Function' },
    { value: 'Only Scrubbing Service', viewValue: 'Only Scrubbing Service' },
    { value: 'Only Delivery Function', viewValue: 'Only Delivery Function' },
  ];

  nonGovSectorListItems: nonGovSectorListItem[] = [
    { value: 'Textile Industry', viewValue: 'Textile Industry' },
    { value: 'Food Processing Industry', viewValue: 'Food Processing Industry' },
    { value: 'Chemical Industry', viewValue: 'Chemical Industry' },
    { value: 'Travel and Tours', viewValue: 'Travel and Tours' },
    { value: 'Ecommerce', viewValue: 'Ecommerce' },
    { value: 'Automobile', viewValue: 'Automobile' },
    { value: 'Construction material', viewValue: 'Construction material' },
    { value: 'Real estate', viewValue: 'Real estate' },
    { value: 'Health care', viewValue: 'Health care' },
    { value: 'Education', viewValue: 'Education' },
    { value: 'IT &Software Industry', viewValue: 'IT &Software Industry' },
    { value: 'BPO', viewValue: 'BPO' },
    { value: 'Entertainment', viewValue: 'Entertainment' },
    { value: 'Investment Broker', viewValue: 'Investment Broker' },
    { value: 'Financial Services/ Institutions', viewValue: 'Financial Services/ Institutions' },
    { value: 'Others', viewValue: 'Others' }

  ]

  //country
  selectedCountrylist: selectedCountry[] = [
    { id: 'India', name: 'India' }
  ];

  //states
  selectedStatelist: selectedState[] = [
    { id: 'Andhra Pradesh', country_id: 'India', name: 'Andhra Pradesh' },
    { id: 'Telagana', country_id: 'India', name: 'Telagana' },
    { id: 'Karnataka', country_id: 'India', name: 'Karnataka' },
  ];

  selectedCitylist: selectedCity[] = [
    { id: 'Anantapur', state_id: 'Andhra Pradesh', name: 'Anantapur' },
    { id: 'Chittoor', state_id: 'Andhra Pradesh', name: 'Chittoor' },
    { id: 'Hyderabad', state_id: 'Telagana', name: 'Hyderabad' },
    { id: 'Kariminagar', state_id: 'Telagana', name: 'Kariminagar' },
    { id: 'Bengalore Urban', state_id: 'Karnataka', name: 'Bengalore Urban' },
    { id: 'Bengalore Rural', state_id: 'Karnataka', name: 'Bengalore Rural' }
  ];

  //poalist 
  poalistitems: poalist[] = [
    { value: 'Firm registration certificate/MSME/UAM/ COI/ COR', viewValue: 'Firm registration certificate/MSME/UAM/ COI/ COR' },
    { value: 'Shop Establishment/ Trade License/Labor Registration', viewValue: 'Shop Establishment/ Trade License/Labor Registration' },
    { value: 'Power/ Telephone bill (<3 months)', viewValue: 'Power/ Telephone bill (<3 months)' },
    { value: 'Others', viewValue: 'Others' }
  ];
  isModifyProfile: boolean = false;
  entityCreator: any;

  getModifyProfile() {
    this.StatusCProfile = true;
    if (this.entityCreator == 'tata') {

      this.entityForm.controls['industry_category'].enable();
      this.entityForm.controls['Organization'].enable();

    } else {
      this.entityForm.controls['industry_category'].disable();
      this.entityForm.controls['Organization'].disable();
      this.$modal.successModal({
        title: 'Entity KYC Renewal',
        msg: 'Please get the name, address and category updated with creator operator in case of difference between the address displayed & your documents. The valid documents to be uploaded here once the change is approved with the parent/ creator operator'
      })

    }
    this.isModifyProfile = false;
    this.modifyOtherDet = false;
    this.isDisabledbtn = false;
    this.isReadonly = false;
    this.modifyOtherDetRemove = true;
    this.entityForm.controls['industry_type'].enable();
    this.entityForm.controls['telemarket_sector'].enable();
    this.entityForm.controls['address1'].enable();
    this.entityForm.controls['address2'].enable();
    this.entityForm.controls['landmark'].enable();
    this.entityForm.controls['selectedCity'].enable();
    this.entityForm.controls['selectedState'].enable();
    this.entityForm.controls['selectedCountry'].enable();
    this.entityForm.controls['pincode'].enable();
    this.entityForm.controls['selectpoa'].enable();
    this.entityForm.controls['selectpoi'].enable();
    this.entityForm.controls['fileuploadpoa'].enable();
    this.entityForm.controls['fileuploadpoi'].enable();
    this.entityForm.controls['fileuploadpoaz'].enable();
    this.entityForm.controls['fileuploadpoazid'].enable();
    this.entityForm.controls['fileuploadother'].enable();
  }

  onPageLoad() {
    this.isModifyProfile = true;
    this.modifyOtherDet = true;
    this.expiryDiffDays = this.es.getCertexpirydiffdays()
    this.hasPasswordExpired = this.es.getCertexpiryFlag()
    this.entityForm.controls['Organization'].disable();
    this.entityForm.controls['industry_category'].disable();
    this.entityForm.controls['industry_type'].disable();
    this.entityForm.controls['telemarket_sector'].disable();
    this.entityForm.controls['address1'].disable();
    this.entityForm.controls['address2'].disable();
    this.entityForm.controls['landmark'].disable();
    this.entityForm.controls['selectedCity'].disable();
    this.entityForm.controls['selectedState'].disable();
    this.entityForm.controls['selectedCountry'].disable();
    this.entityForm.controls['pincode'].disable();
    this.entityForm.controls['selectpoa'].disable();
    this.entityForm.controls['selectpoi'].disable();
    this.entityForm.controls['fileuploadpoa'].disable();
    this.entityForm.controls['fileuploadpoi'].disable();
    this.entityForm.controls['fileuploadpoaz'].disable();
    this.entityForm.controls['fileuploadpoazid'].disable();
    this.entityForm.controls['fileuploadother'].disable();
  }

  ngOnInit() {
    this.entityForm = this.fb.group({
      FC_PE: [''],
      FC_TM: [''],
      FC_TA: [''],
      TM_Type: ['',],
      Organization: ['', [Validators.required, Validators.pattern('^(?! ).*(?<! )$')]],
      pantanno: ['', [Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/), Validators.minLength(10), Validators.maxLength(10)]],
      //email: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9._]+@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,3})*$/)]],
      email: ['', [Validators.required, Validators.pattern('^[A-Za-z0-9._-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,10}$')]],
      mobileno: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10)]],
      auth_signature: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]],
      //gstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([zZ]){1}([a-zA-Z0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
      gstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{4,5}([0-9]){4,5}([a-zA-Z]){1}([0-9]){1}([a-zA-Z0-9]){1}([a-zA-Z0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
      address1: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
      address2: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(100)]],
      dltAddress: ['',],
      landmark: ['',],
      selectedCountry: ['', [Validators.required]],
      selectedState: ['', [Validators.required]],
      selectedCity: ['', [Validators.required]],
      pincode: ['', [Validators.required, Validators.pattern("^[0-9]+$"), Validators.minLength(6), Validators.maxLength(6)]],
      telemarket_sector: ['',],
      //uploadPOI: ['', [Validators.required]],
      selectpoi: ['', [Validators.required]],
      selectpoa: ['', [Validators.required]],
      otherdocname: ['',],
      industry_category: ['', [Validators.required]],
      industry_type: ['', [Validators.required]],
      others_indType: ['',],
      others_sector: ['',],
      emailotpno: ['', [Validators.required, Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)]],
      mobileotpno: ['', [Validators.required, Validators.pattern("^[0-9]+$"), Validators.minLength(4), Validators.maxLength(4)]],
      modifyreason: ['',],
      reg_remarks: ['',],
      confirmgstid: ['',],
      //confirmgstid: ['', [Validators.pattern(/^(([0-9]){2}[a-zA-Z]{5}([0-9]){4}([a-zA-Z]){1}([0-9]){1}([zZ]){1}([0-9]){1})*$/), Validators.minLength(15), Validators.maxLength(15)]],
      //panno: ['', [Validators.required, Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/), Validators.minLength(10), Validators.maxLength(10)]],
      //selectpoipan: ['', [Validators.required]],
      tanno: ['', [Validators.pattern(/^([a-zA-Z]){4}([0-9]){5}([a-zA-Z]){1}?$/), Validators.minLength(10), Validators.maxLength(10)]],

      fileuploadpoi: [''],
      fileuploadpoa: [''],
      fileuploadpoaz: [''],
      fileuploadpoazid: [''],
      govtfileupload: [''],
      fileuploadsebi: [''],
      fileuploadgst: [''],
      fileuploadother: ['']
    },
      {
        validator: MustMatch('gstid', 'confirmgstid')
      })//end of entityForm

    this.es.getEntityDetailsID(this.entityId)
      .subscribe(r => {
        this.response = r;
        if (r.POI_Type == "PAN") {
          this.PANshow = true
          this.entityForm.controls['pantanno'].setValue(r.POI)

        } else if (r.POI_Type == "TAN") {
          this.TANshow = true
          this.entityForm.controls['tanno'].setValue(r.POI)
        }
        let res;
        if (r.Kyc_Status == "C") {
          res = r.Previous_Data;
        } else {
          res = r;
        }
        this.Entity_Ref_No = res.Entity_Ref_No
        this.Common_ID = res.Common_ID
        this.Registered_Operator = res.Registered_Operator
        this.Registered_ID = res.Registered_ID
        this.entityForm.controls['industry_category'].setValue(res.E_Org_Type)

        if (res.E_Org_Type == "G") {
          this.poilistitems = [
            { value: 'PAN', viewValue: 'PAN' },
            { value: 'TAN', viewValue: 'TAN' }
          ]

        } else {
          this.poilistitems = [
            { value: 'PAN', viewValue: 'PAN' },
          ]
        }
        this.entityForm.controls['selectpoi'].setValue(res.POI_Type)


        this.entityCreator = res.Entity_Creator;
        if (res.Entity_Creator == 'tata') {
          this.entityCreatorAddress = true;
        } else {
          this.entityForm.controls['dltAddress'].setValue(res.Entity_Addr || '');

          //    this.entityForm.controls['telemarket_sector'].setValidators([Validators.required]);
          //    this.entityForm.controls['telemarket_sector'].updateValueAndValidity();
          //    //this.getvalidation();

        }

        this.entityForm.controls['email'].setValue(res.Entity_EmailID)
        this.entityForm.controls['mobileno'].setValue(res.Entity_Mobile_No)
        this.regEmail = res.Entity_EmailID
        this.regMobile = res.Entity_Mobile_No



      })
    this.peFlag = true //disable PE
    this.tmFlag = true //disable TM 
    this.taFlag = true //disable TA
    // this.entityForm.controls['fileuploadpoi'].disable();
    this.onPageLoad();

    this.expiryDiffDays = this.es.getCertexpirydiffdays()
    this.hasPasswordExpired = this.es.getCertexpiryFlag()

    this.calculatedays();
    this.subscription = interval(24 * 60 * 60 * 10).subscribe(() => {
      this.calculatedays();
    })

  }

  //on poi, email, mobile submit
  modSendEMOTP(val) {
    if ((this.expiryDiffDays >= 0 && this.expiryDiffDays <= 30) || this.hasPasswordExpired) {
      if (val == "both") {
      this.modalRef = this.modalService.show(ModalPromptEntityComponent)
      this.modalRef.content.modalDataObj = {
          title: "Entity KYC Renewal",
        msg: "This page changes will lead to Entity renewal post approval. Do you want to continue?",
        btnYes: 'Yes',
        btnNo: 'No'
      }

      this.modalRef.content.onClose.subscribe(result => {
        this.returnedValue = result

        if (this.returnedValue == true) {
          this.isReadonly = true
          this.modifyOtherDet = true;
          this.modifyOtherDetRemove = false;
          this.isemailMobileReadonly = true;

          this.ishide = true;
          this.otpinfo = true;
          let _poi
          if (this.entityForm.get("selectpoi").value == "PAN")
            _poi = this.entityForm.get("pantanno").value
          else
            _poi = this.entityForm.get("tanno").value

          if (this.regEmail != this.entityForm.get("email").value)
            this.isEmailMod = true
          if (this.regMobile != this.entityForm.get("mobileno").value)
            this.isMobileMod = true

          if (this.isEmailMod && this.isMobileMod) {
            val = "both"
          }
          else if (this.isEmailMod) {
            val = "email"
                this.entityForm.controls['mobileotpno'].setValue("9999") //to avoid required field validation
            this.mobileVerify = true
          }
          else if (this.isMobileMod) {
            val = "mobile"
               this.entityForm.controls['emailotpno'].setValue("9999") //to avoid required field validation 
             
            this.emailVerify = true
          }
          else {
            val = "NA" //not applicable
               this.entityForm.controls['emailotpno'].setValue("9999") //to avoid required field validation
               this.entityForm.controls['mobileotpno'].setValue("9999") //to avoid required field validation 
            this.emailVerify = true
            this.mobileVerify = true

          }

          let data = {
            "otpFor": val,
            "refNo": this.entityId,
            "POI": _poi,
            "emailId": this.entityForm.get("email").value,
            "mobileNo": this.entityForm.get("mobileno").value,
            "emailMod": this.isEmailMod,
            "mobileMod": this.isMobileMod,
          }
          this.es.modSendEMOTP(data)
            .subscribe(r => {

              this.dltFlag = false

              if (!this.dltFlag && this.emailVerify && this.mobileVerify) {
                this.onContinue()
                this.dltFlag = true //to hide continue button 
              }
              if (data.otpFor == "email") {
                  this.otpEmail = r.Email_OTP;
                this.otpEExp = r.Email_OTP_Time + 600000

              } else if (data.otpFor == "mobile") {
                  this.otpMobile = r.Mobile_OTP;
                this.otpMExp = r.Mobile_OTP_Time + 600000

              } else if (data.otpFor == "both") {
                  this.otpEmail = r.Email_OTP;
                  this.otpMobile = r.Mobile_OTP;
                this.otpEExp = r.Email_OTP_Time + 600000
                this.otpMExp = r.Mobile_OTP_Time + 600000
              } else {
              }
            })
        }
      })
    } else {
        this.isReadonly = true
        this.modifyOtherDet = true;
        this.modifyOtherDetRemove = false;
        this.isemailMobileReadonly = true;
       
        this.ishide = true;
        this.otpinfo = true;
        let _poi
        if (this.entityForm.get("selectpoi").value == "PAN")
          _poi = this.entityForm.get("pantanno").value
        else
          _poi = this.entityForm.get("tanno").value

        if (this.regEmail != this.entityForm.get("email").value)
          this.isEmailMod = true
        if (this.regMobile != this.entityForm.get("mobileno").value)
          this.isMobileMod = true

        if (this.isEmailMod && this.isMobileMod) {
          val = "both"
        }
        else if (this.isEmailMod) {
          val = "email"
           this.entityForm.controls['mobileotpno'].setValue("9999") //to avoid required field validation
          this.mobileVerify = true
        }
        else if (this.isMobileMod) {
          val = "mobile"
          this.emailVerify = true
           this.entityForm.controls['emailotpno'].setValue("9999") //to avoid required field validation 
        }
        else {
          val = "NA" //not applicable
           this.entityForm.controls['emailotpno'].setValue("9999") //to avoid required field validation
           this.entityForm.controls['mobileotpno'].setValue("9999") //to avoid required field validation 
          this.emailVerify = true
          this.mobileVerify = true

        }

        let data = {
          "otpFor": val,
          "refNo": this.entityId,
          "POI": _poi,
          "emailId": this.entityForm.get("email").value,
          "mobileNo": this.entityForm.get("mobileno").value,
          "emailMod": this.isEmailMod,
          "mobileMod": this.isMobileMod,
        }
        this.es.modSendEMOTP(data)
          .subscribe(r => {

            this.dltFlag = false

            if (!this.dltFlag && this.emailVerify && this.mobileVerify) {
              this.onContinue()
              this.dltFlag = true //to hide continue button 
            }
            if (data.otpFor == "email") {
              this.otpEmail = r.Email_OTP;
              this.otpEExp = r.Email_OTP_Time + 600000

            } else if (data.otpFor == "mobile") {
              this.otpMobile = r.Mobile_OTP;
              this.otpMExp = r.Mobile_OTP_Time + 600000

            } else if (data.otpFor == "both") {
              this.otpEmail = r.Email_OTP;
              this.otpMobile = r.Mobile_OTP;
              this.otpEExp = r.Email_OTP_Time + 600000
              this.otpMExp = r.Mobile_OTP_Time + 600000
            } else {
            }
          })
      }
    } else {
      this.modalRef = this.modalService.show(ModalPromptComponent);
      this.modalRef.content.modalDataObj = {
        title: "Entity KYC Renewal",
        msg: "Entity renewal can be done before 30 days from expiry date."
      }
      this.modalRef.content.onClose.subscribe(result => {
        this.returnedValue = result
        if (this.returnedValue == true) {
          this.router.navigateByUrl('/tmpe-modify-after-approval')
        }
      });
    }
  }//modSendEMOTP

  downloadold(file1, entityId) {

    var data = {
      "Entity_ID": entityId,
      "FileType": "KYC",
      "FileName": file1

    }

    this.es.download(data).subscribe(r => {


      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Entity KYC Renewal',
        msg: 'File has been downloaded Successfully'
      });
    })
  }
  
  verifyEOTP() {
    let eOTP = this.entityForm.get("emailotpno").value
    if (eOTP.length != 4) {
      this.$modal.errorModal({
        title: 'Entity KYC Renewal',
        msg: 'Enter valid OTP'
      })
      return;
    }
    let currenttime = Date.now()
    console.log("eOTP : ", eOTP)
    if (eOTP == "") {
      this.$modal.errorModal({
        title: 'Entity KYC Renewal',
        msg: 'Otp field is kept'
      })
    }
    else if (eOTP == this.otpEmail) {
      if (currenttime > this.otpEExp) {
        this.$modal.errorModal({
          title: 'Entity KYC Renewal',
          msg: 'OTP has expired!'
        })
      } else {
        this.changeEmailMobile = true
        this.emailVerify = true
        this.disableEotp = true;
        this.isDisabledbtn = false
        this.$modal.successModal({
          title: 'Entity KYC Renewal',
          msg: 'Email OTP verified!'
        })
      }
    } else {
      this.$modal.errorModal({
        title: 'Entity KYC Renewal',
        msg: 'Entered wrong OTP!'
      })
    }
  }

  verifyMOTP() {
    let mOTP = this.entityForm.get("mobileotpno").value
    if (mOTP.length != 4) {
      this.$modal.errorModal({
        title: 'Entity KYC Renewal',
        msg: 'Enter valid OTP'
      })
      return;
    }
    let currenttime = Date.now()
    console.log("mOTP, this.otpMobile ", mOTP, " - ", this.otpMobile)
    if (mOTP == "") {
      this.$modal.errorModal({
        title: 'Entity KYC Renewal',
        msg: 'Otp field is kept'
      })
    }

    else if (mOTP == this.otpMobile) {
      if (currenttime > this.otpMExp) {
        this.$modal.errorModal({
          title: 'Entity KYC Renewal',
          msg: 'OTP has expired!'
        })
      } else {
        this.changeEmailMobile = true
        this.mobileVerify = true;
        this.disableMotp = true;
        this.isDisabledbtn = false
        this.$modal.successModal({
          title: 'Entity KYC Renewal',
          msg: 'Mobile OTP verified!'
        })
      }
    } else {
      this.$modal.errorModal({
        title: 'Entity KYC Renewal',
        msg: 'Entered wrong OTP!'
      })
    }
  }

  //onContinue button click 
  onContinue() {
    this.addrinfo = true;
    this.ishidecontinue = true;
    this.entityForm.controls['fileuploadother'].disable();

    this.es.getEntityDetailsID(this.entityId)
      .subscribe(r => {
        if (r.profileStatus == 'C' || r.Kyc_Status == 'C') {
          this.StatusC = true;
          this.StatusCProfile = true;
          this.isDisabledbtn = true;
        }
        if (r.profileStatus == 'P' || r.Kyc_Status == 'P') {
					this.StatusP = true
          this.StatusCProfile = true;
          this.isDisabledbtn = true;
				}
        let res;
        if (r.Kyc_Status == "C") {
          res = r.Previous_Data;
        } else {
          res = r;
        }
        /*
        if(this.peRegistered) {
          this.entityForm.controls['FC_PE'].setValue("PE")
          this.peFlag = true //disable PE
        	
          //disable TA
          this.taFlag = true
        }
        if(this.tmRegistered) {
          this.entityForm.controls['FC_TM'].setValue("TM")
          //this.entityForm.controls['TM_Type'].setValue(r.Entity_TM_Type)
          this.tmFlag = true
          //this.teledroplist = true
        	
          //disable TA
          this.taFlag = true
        }
        */
        //mongo classifications  
        if (res.Entity_Class == "PE") {
          //this.selectedPE = true 
          this.entityForm.controls['FC_PE'].setValue("PE")
          // this.peFlag = true //disable PE
          // this.taFlag = true //disable TA 
          this.PETrue = true;
        }
        if (res.Entity_Class == "TM") {
          //this.selectedTM = true
          this.entityForm.controls['FC_TM'].setValue("TM")
          this.entityForm.controls['TM_Type'].setValue(res.Entity_TM_Type)
          this.teledroplist = true
          // this.tmFlag = true //disable TM 
          // this.taFlag = true //disable TA 
          this.TMTrue = true;
        }
        /*
        if(res.PE == "PE" && res.TM == "TM"){
          this.RegisterNewCalrificationbtn=false;
          this.entityForm.controls['TM_Type'].disable();
        } */
        if (res.Entity_Class == "TA") {
          //this.selectedTA = true		 		
          this.entityForm.controls['FC_TA'].setValue("TA")
          // this.peFlag = true //disable PE
          // this.tmFlag = true //disable TM 
          // this.taFlag = true //disable TA
          this.TATrue = true;
          this.RegisterNewCalrificationbtn = false;
        }



        this.entityForm.controls['Organization'].setValue(res.E_Org_Name)
        this.entityForm.controls['auth_signature'].setValue(res.Entity_AuthSignName)
        this.entityForm.controls['gstid'].setValue(res.Entity_GST_Id)
        this.confirmgstid = res.Entity_GST_Id;
        if (res.Entity_GST_Id === "" || res.Entity_GST_Id === undefined) {
          this.gstDoc = false
          this.entityForm.controls['fileuploadgst'].clearValidators()
        }
        else {
          this.gstDoc = true
          this.entityForm.controls['fileuploadgst'].setValidators([Validators.required])
          this.entityForm.controls['fileuploadgst'].updateValueAndValidity()
        }

        if (this.entityForm.get("industry_category").value == "G") {
          this.industryCategory = "G"
          this.indListItems = [
            { value: 'Banking', viewValue: 'Banking' },
            { value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
            { value: 'Education', viewValue: 'Education' },
            { value: 'Emergency Services', viewValue: 'Emergency Services' },
            { value: 'Healthcare', viewValue: 'Healthcare' },
            { value: 'Safety', viewValue: 'Safety' },
            { value: 'Environmental Protection', viewValue: 'Environmental Protection' },
            { value: 'Law & Order', viewValue: 'Law & Order' },
            { value: 'Consumer Protection', viewValue: 'Consumer Protection' },
            { value: 'Others', viewValue: 'Others' },
          ]
          this.entityForm.controls['telemarket_sector'].clearValidators()
          this.entityForm.controls['telemarket_sector'].updateValueAndValidity()

        } else {
          this.industryCategory = "P"
          this.indListItems = [
            { value: 'Private Limited Company', viewValue: 'Private Limited Company' },
            { value: 'Public Limited Company', viewValue: 'Public Limited Company' },
            { value: 'Cooperative', viewValue: 'Cooperative' },
            { value: 'Franchise', viewValue: 'Franchise' },
            { value: 'NGO', viewValue: 'NGO' },
            { value: 'Investments', viewValue: 'Investments' },
            { value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
            { value: 'Sole Proprietorship', viewValue: 'Sole Proprietorship' },
            { value: 'Partnership', viewValue: 'Partnership' },
            { value: 'Banking', viewValue: 'Banking' },
            { value: 'Insurance', viewValue: 'Insurance' },
            { value: 'Political Party', viewValue: 'Political Party' },
            { value: 'Others', viewValue: 'Others' }
          ]
          this.entityForm.controls['telemarket_sector'].setValidators([Validators.required])
          this.entityForm.controls['telemarket_sector'].updateValueAndValidity()
        }

        this.entityForm.controls['industry_type'].setValue(res.Entity_Industry)
        if (r.Entity_Industry == "Others") {
          this.otherindtypeshow = true
          this.entityForm.controls['others_indType'].setValue(res.Entity_Industry_Other)
        }

        this.entityForm.controls['telemarket_sector'].setValue(res.Entity_Sector)
        if (res.Entity_Sector == "Others") {
          this.othersectorshow = true
          this.entityForm.controls['others_sector'].setValue(res.Entity_Sector_Other)
        }
        this.entityForm.controls['industry_type'].disable()
        this.entityForm.controls['telemarket_sector'].disable();


        this.entityForm.controls['address1'].setValue(res.Entity_Addr1)
        this.entityForm.controls['address2'].setValue(res.Entity_Addr2)
        this.entityForm.controls['landmark'].setValue(res.Entity_Landmark)
        this.entityForm.controls['selectedCountry'].setValue(res.Entity_Country)
        this.selectedCountryId = res.Entity_Country;
        this.onChangeCountry()
        this.entityForm.controls['selectedState'].setValue(res.Entity_State)
        this.selectedStateId = res.Entity_State;
        this.onChangeState()
        this.entityForm.controls['selectedCity'].setValue(res.Entity_City)
        this.entityForm.controls['pincode'].setValue(res.Entity_Pincode)
        // to verify the address change on submit and popup POA
        this.addr1 = res.Entity_Addr1
        this.addr2 = res.Entity_Addr2
        this.landmk = res.Entity_Landmark
        this.country = res.Entity_Country
        this.city = res.Entity_City
        this.pincd = res.Entity_Pincode
        this.state = res.Entity_State
        this.entityForm.controls['otherdocname'].setValue(res.Other_Doc_Name)
        if (res.E_Org_Type == "S" || res.Entity_Industry == 'Investment Broker (SEBI)') {
          this.isSEBI = true
          this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required])
          this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
        }
        this.entityForm.controls['selectpoi'].setValue(res.POI_Type)
        this.entityForm.controls['selectpoa'].setValue(res.POA)

        if (res.Entity_POI_Doc != "" && res.Entity_POI_Doc != undefined) {
          this.entityForm.controls['fileuploadpoi'].disable();
          this.Entity_POI_Doc = res.Entity_POI_Doc.substring(res.Entity_POI_Doc.indexOf('.') + 1)
        } else {
          this.Entity_POI_Doc = ""
        }

        if (res.Entity_POA_Doc != "" && res.Entity_POA_Doc != undefined) {
          this.entityForm.controls['fileuploadpoa'].disable();
          this.Entity_POA_Doc = res.Entity_POA_Doc.substring(res.Entity_POA_Doc.indexOf('.') + 1)
        } else {
          this.Entity_POA_Doc = ""
        }

        if (res.Entity_SEBI_Doc != "" && res.Entity_SEBI_Doc != undefined) {
          this.entityForm.controls['fileuploadsebi'].disable();
          this.Entity_SEBI_Doc = res.Entity_SEBI_Doc.substring(res.Entity_SEBI_Doc.indexOf('.') + 1)
        } else {
          this.Entity_SEBI_Doc = ""
        }

        if (res.Entity_GST_Doc != "" && res.Entity_GST_Doc != undefined) {
          this.entityForm.controls['fileuploadgst'].disable();
          this.Entity_GST_Doc = res.Entity_GST_Doc.substring(res.Entity_GST_Doc.indexOf('.') + 1)
        } else {
          this.Entity_GST_Doc = ""
        }

        if (res.Entity_POAZ_Doc != "" && res.Entity_POAZ_Doc != undefined) {
          this.entityForm.controls['fileuploadpoaz'].disable();
          this.Entity_POAZ_Doc = res.Entity_POAZ_Doc.substring(res.Entity_POAZ_Doc.indexOf('.') + 1)
          //this.myfilepoazDuplicate.push({name: this.Entity_POAZ_Doc, value: this.Entity_POAZ_Doc})

        } else {
          this.Entity_POAZ_Doc = ""
        }

        if (res.Entity_POAZID_Doc != "" && res.Entity_POAZID_Doc != undefined) {
          this.entityForm.controls['fileuploadpoazid'].disable();
          this.Entity_POAZID_Doc = res.Entity_POAZID_Doc.substring(res.Entity_POAZID_Doc.indexOf('.') + 1)
          //this.myfilepoazidDuplicate.push({name: this.Entity_POAZID_Doc, value: this.Entity_POAZID_Doc})

        } else {
          this.Entity_POAZID_Doc = ""
        }
        if (res.Entity_Other_Doc != "" && res.Entity_Other_Doc != undefined) {
          //this.entityForm.controls['fileuploadother'].disable();
          this.Entity_Other_Doc = res.Entity_Other_Doc.substring(res.Entity_Other_Doc.indexOf('.') + 1)
          // this.myfileotherDuplicate.push({ name: this.Entity_Other_Doc, value: this.Entity_Other_Doc })

        } else {
          this.Entity_Other_Doc = ""
        }

        if (res.Entity_Other_Doc1 != "" && res.Entity_Other_Doc1 != undefined) {
          //this.entityForm.controls['fileuploadother'].disable();
          // this.myfileotherDuplicate.push({ name: this.Entity_Other_Doc, value: this.Entity_Other_Doc })

          this.Entity_Other_Doc1 = res.Entity_Other_Doc1.substring(res.Entity_Other_Doc1.indexOf('.') + 1)
        } else {
          this.Entity_Other_Doc1 = ""
        }
        if (this.myfileotherDuplicate.length == 2) {
          // this.entityForm.controls['fileuploadother'].disable();

        }


        //old documents 
        if (res.Hash_KYC_Doc != "" && res.Hash_KYC_Doc != undefined) {
          this.Hash_KYC_Doc = r.Hash_KYC_Doc.substring(res.Hash_KYC_Doc.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc", value: this.Hash_KYC_Doc })
        } else {
          this.Hash_KYC_Doc = ""
        }

        if (res.Hash_KYC_Doc1 != "" && res.Hash_KYC_Doc1 != undefined) {
          this.Hash_KYC_Doc1 = r.Hash_KYC_Doc1.substring(res.Hash_KYC_Doc1.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc1", value: this.Hash_KYC_Doc1 })
        } else {
          this.Hash_KYC_Doc1 = ""
        }

        if (res.Hash_KYC_Doc2 != "" && res.Hash_KYC_Doc2 != undefined) {
          this.Hash_KYC_Doc2 = res.Hash_KYC_Doc.substring(res.Hash_KYC_Doc2.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc2", value: this.Hash_KYC_Doc2 })
        } else {
          this.Hash_KYC_Doc2 = ""
        }

        if (res.Hash_KYC_Doc3 != "" && res.Hash_KYC_Doc3 != undefined) {
          this.Hash_KYC_Doc3 = res.Hash_KYC_Doc3.substring(res.Hash_KYC_Doc3.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc3", value: this.Hash_KYC_Doc3 })
        } else {
          this.Hash_KYC_Doc3 = ""
        }

        if (res.Hash_KYC_Doc4 != "" && res.Hash_KYC_Doc4 != undefined) {
          this.Hash_KYC_Doc4 = res.Hash_KYC_Doc4.substring(res.Hash_KYC_Doc4.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc4", value: this.Hash_KYC_Doc4 })
        } else {
          this.Hash_KYC_Doc4 = ""
        }

        if (res.Hash_KYC_Doc5 != "" && res.Hash_KYC_Doc5 != undefined) {
          this.Hash_KYC_Doc5 = res.Hash_KYC_Doc5.substring(res.Hash_KYC_Doc5.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc5", value: this.Hash_KYC_Doc5 })
        } else {
          this.Hash_KYC_Doc5 = ""
        }

        if (res.Hash_KYC_Doc6 != "" && res.Hash_KYC_Doc6 != undefined) {
          this.Hash_KYC_Doc6 = res.Hash_KYC_Doc6.substring(res.Hash_KYC_Doc6.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc6", value: this.Hash_KYC_Doc6 })
        } else {
          this.Hash_KYC_Doc6 = ""
        }

        if (res.Hash_KYC_Doc7 != "" && res.Hash_KYC_Doc7 != undefined) {
          this.Hash_KYC_Doc7 = res.Hash_KYC_Doc7.substring(res.Hash_KYC_Doc7.indexOf('.') + 1)
          this.oldDocs.push({ name: "Hash_KYC_Doc7", value: this.Hash_KYC_Doc7 })
        } else {
          this.Hash_KYC_Doc7 = ""
        }

      })
  }//onContinue

  //entity classification on change event fire 
  onCheckboxChagen(event, value) {
    //capture selcted eclasses
    if (event.checked) {
      if (value == "PE") {
        this.selectedPE = true

      } if (value == "TM") {
        this.selectedTM = true

      } if (value == "TA") {
        this.selectedTA = true

      }
    }
    if (!event.checked) {
      if (value == "PE") {
        this.selectedPE = false

      } if (value == "TM") {
        this.selectedTM = false

      } if (value == "TA") {
        this.selectedTA = false

      }
    }
    /*
    //check PE/TM selects TA
    if(this.selectedPE && this.selectedTA) {
      this.selectedTA = false
      this.taChecked = false
      this.$modal.errorModal({ 
        title: 'Entity- Kyc -Renewal',
        msg: 'PE cannot be TA!'
      })
    } if(this.selectedTM && this.selectedTA) {
      this.selectedTA = false
      this.taChecked = false
      this.$modal.errorModal({ 
        title: 'Entity- Kyc -Renewal',
        msg: 'TM cannot be TA!' 
      })
    } 
    */

    //tm dropdown display
    if (this.selectedTM) {
      this.teledroplist = true
      this.regEclass = "TM"
      this.entityForm.controls['TM_Type'].setValidators([Validators.required])
      this.entityForm.controls['TM_Type'].updateValueAndValidity()
    } else {
      this.teledroplist = false
      this.regEclass = "PE"
      this.entityForm.controls['TM_Type'].reset()
      this.entityForm.controls['TM_Type'].clearValidators()
      this.entityForm.controls['TM_Type'].updateValueAndValidity()
    }

    if (this.tmFlag)
      this.teledroplist = true

  }


  resetOther(id) {

    this.myfileother = this.myfileother.filter(function (obj) {
      return obj.name !== id.name;
    })
    this.myfileotherDuplicate = this.myfileotherDuplicate.filter(function (obj) {
      return obj.name !== id.name;
    })


  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  calculatedays() {
    const currentdate = new Date();
    const differenceindays = Math.floor((this.expirationdate.getTime() - currentdate.getTime()) / (24 * 60 * 60 * 1000))

    this.daysRemaining = differenceindays;
    if (differenceindays <= 5 && differenceindays >= 0) {
      this.showalert = true;
    } else {
      this.showalert = false;
    }


  }

  onChangeIndCategory(event) {
    if (event.value == "G") {
      this.poilistitems = [
        { value: 'PAN', viewValue: 'PAN' },
        { value: 'TAN', viewValue: 'TAN' }
      ]
      this.indListItems = [
        { value: 'Banking', viewValue: 'Banking' },
        { value: 'Investment Broker (SEBI)', viewValue: 'Investment Broker (SEBI)' },
        { value: 'Education', viewValue: 'Education' },
        { value: 'Emergency Services', viewValue: 'Emergency Services' },
        { value: 'Healthcare', viewValue: 'Healthcare' },
        { value: 'Safety', viewValue: 'Safety' },
        { value: 'Environmental Protection', viewValue: 'Environmental Protection' },
        { value: 'Law & Order', viewValue: 'Law & Order' },
        { value: 'Consumer Protection', viewValue: 'Consumer Protection' },
        { value: 'Others', viewValue: 'Others' },
      ]
      this.entityForm.controls['telemarket_sector'].clearValidators()
      this.entityForm.controls['telemarket_sector'].updateValueAndValidity()
    } else {
      this.poilistitems = [
        { value: 'PAN', viewValue: 'PAN' },
      ]
      this.indListItems = [
        { value: 'Private Limited Company', viewValue: 'Private Limited Company' },
        { value: 'Public Limited Company', viewValue: 'Public Limited Company' },
        { value: 'Cooperative', viewValue: 'Cooperative' },
        { value: 'Franchise', viewValue: 'Franchise' },
        { value: 'NGO', viewValue: 'NGO' },
        { value: 'Investments', viewValue: 'Investments' },
        { value: 'Investments Broker(SEBI)', viewValue: 'Investments Broker(SEBI)' },
        { value: 'Sole Proprietorship', viewValue: 'Sole Proprietorship' },
        { value: 'Partnership', viewValue: 'Partnership' },
        { value: 'Banking', viewValue: 'Banking' },
        { value: 'Insurance', viewValue: 'Insurance' },
        { value: 'Political Party', viewValue: 'Political Party' },
        { value: 'Others', viewValue: 'Others' }
      ]
      this.entityForm.controls['telemarket_sector'].setValidators([Validators.required])
      this.entityForm.controls['telemarket_sector'].updateValueAndValidity()
    }
    if (event.value == "S") {
      this.isSEBI = true
      this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required])
      this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
    } else {
      this.isSEBI = false
      this.entityForm.controls['fileuploadsebi'].clearValidators()
      this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
    }
  }

  onChangeCountry() {

    this.newlistitems = [];

    this.es.getAllStates(this.selectedCountryId)
      .subscribe(r => {


        this.newlistitems = r

      })
  }

  //newstatelistitems
  onChangeState() {

    this.newstatelistitems = [];

    this.es.getCitiesByStateName(this.selectedStateId)
      .subscribe(r => {
        this.newstatelistitems = r

      })
  }

  onChangeIndType(event) {
    if (event.value == "Others") {
      this.otherindtypeshow = true;
      this.entityForm.controls['others_indType'].setValidators([Validators.pattern('^[A-Za-z \-\']+'), Validators.required, Validators.minLength(3), Validators.maxLength(50)])
    }
    else {
      this.otherindtypeshow = false;
      this.entityForm.controls['others_indType'].clearValidators()
      this.entityForm.controls['others_indType'].updateValueAndValidity()
    }

    if (event.value == "Investment Broker (SEBI)" || this.industryCategory == "S") {
      this.isSEBI = true
      this.entityForm.controls['fileuploadsebi'].setValidators([Validators.required])
      this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
    }
    else {
      this.isSEBI = false
      this.entityForm.controls['fileuploadsebi'].clearValidators()
      this.entityForm.controls['fileuploadsebi'].updateValueAndValidity()
    }
  }

  onchangesector(event) {
    if (event.value == "Others") {
      this.othersectorshow = true;
      this.entityForm.controls['others_sector'].setValidators([Validators.pattern('^[A-Za-z \-\']+'), Validators.required, Validators.minLength(3), Validators.maxLength(50)])
    }
    else {
      this.othersectorshow = false;
      this.entityForm.controls['others_sector'].clearValidators()
      this.entityForm.controls['others_sector'].updateValueAndValidity()
    }
  }

  download(file1, filetype) {
    var data = {
      "Entity_Ref_No": this.Entity_Ref_No,
      "Folder": filetype,
      "FileName": file1,
    }
    this.es.modifyFileDownload(data).subscribe(r => {
      this.downloadFile(r, file1);
      this.$modal.successModal({
        title: 'Entity KYC Renewal',
        msg: 'File has been downloaded Successfully'
      });
    })
  }

  private downloadFile(res: any, filename: string): void {
    const url = window.URL.createObjectURL(res)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.setAttribute('style', 'display: none')
    a.href = url;
    a.download = filename;
    a.click()
    window.URL.revokeObjectURL(url)
    a.remove()
  }

  reset(id) {
    this.entityForm.controls[id].reset();
    // this.btndisabled = true;
    if (id == "fileuploadpoi") {
      this.myfilepoi = [];
    }
    if (id == "fileuploadpoa") {
      this.myfilepoa = [];
    }
    if (id == "fileuploadgst") {
      this.myfilegst = [];
    }
    if (id == "fileuploadsebi") {
      this.myfilesebi = [];

    }
    if (id == "fileuploadpoaz") {
      this.myfilepoaz = [];
    }
    if (id == "fileuploadpoazid") {
      this.myfilepoazid = [];
    }
    if (id == "fileuploadother") {
      this.myfileother = [];
    }

  }


  deleteDocument(file1, entityId, file_Hash_KYC_Doc, filetype, formcontrolname) {
    this.modalRef = this.modalService.show(ModalPromptComponent);
    this.modalRef.content.modalDataObj = {
      title: "Entity KYC Renewal",
      msg: "Are you sure you want to delete this file"
    }
    this.modalRef.content.onClose.subscribe(result => {
      this.returnedValue = result
      if (this.returnedValue == true) {
        var data = {
          "Entity_Ref_No": this.Entity_Ref_No,
          "FileType": filetype,
          "FileName": file1,
          "file_Hash_KYC_Doc": file_Hash_KYC_Doc,
        }

        this.$modal.successModal({
          title: 'Entity KYC Renewal',
          msg: 'File has been deleted Successfully'

        });
        this.entityForm.controls[formcontrolname].enable()
        if (formcontrolname != "fileuploadother") {
          this.entityForm.controls[formcontrolname].setValidators([Validators.required])
          this.entityForm.controls[formcontrolname].updateValueAndValidity()
        }

        if (file_Hash_KYC_Doc == "Entity_POI_Doc") {
          this.Entity_POI_Doc = ""

        } else if (file_Hash_KYC_Doc == "Entity_POA_Doc") {
          this.Entity_POA_Doc = ""

        } else if (file_Hash_KYC_Doc == "Entity_GST_Doc") {
          this.Entity_GST_Doc = ""

        } else if (file_Hash_KYC_Doc == "Entity_SEBI_Doc") {
          this.Entity_SEBI_Doc = ""

        } else if (file_Hash_KYC_Doc == "Entity_POAZ_Doc") {
          this.Entity_POAZ_Doc = ""

        }
        else if (file_Hash_KYC_Doc == "Entity_POAZID_Doc") {
          this.Entity_POAZID_Doc = ""

        }
        else if (file_Hash_KYC_Doc == "Entity_Other_Doc") {
          this.myfileotherDuplicate.splice(file1, 1)

          this.Entity_Other_Doc = ""

        } else if (file_Hash_KYC_Doc == "Entity_Other_Doc1") {
          this.myfileotherDuplicate.splice(file1, 1)

          this.Entity_Other_Doc1 = ""
        }

      }
    })
  }


  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }
  onChangeFileUpload(event, id) {
    console.log("event entity kyc process", event.target.files)
    var file = event.target.files[0];
    this.photoName = file.name;
    var allowedExtensions = ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG", "pdf"]
    this.fileExtension = this.photoName.split('.').pop().toLowerCase();


    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;

      if (id == "fileuploadpoi") {

        if (file.size > 4242880)
          this.fileuploadpoiMax = true
        else
          this.fileuploadpoiMax = false
        if (file.size <= 0)
          this.fileuploadpoiMin = true
        else
          this.fileuploadpoiMin = false

        this.poifileExtensionError = false;
        this.myfilepoi.push(event.target.files[0])

      } else if (id == "fileuploadpoa") {

        if (file.size > 4242880)
          this.fileuploadpoaMax = true
        else
          this.fileuploadpoaMax = false

        if (file.size <= 0)
          this.fileuploadpoaMin = true
        else
          this.fileuploadpoaMin = false

        this.poafileExtensionError = false;
        this.myfilepoa.push(event.target.files[0])

      } else if (id == "fileuploadsebi") {

        if (file.size > 4242880)
          this.fileuploadsebiMax = true
        else
          this.fileuploadsebiMax = false

        if (file.size <= 0)
          this.fileuploadsebiMin = true
        else
          this.fileuploadsebiMin = false

        this.sebifileExtensionError = false;
        this.myfilesebi.push(event.target.files[0])

      } else if (id == "fileuploadgst") {

        if (file.size > 4242880)
          this.fileuploadgstMax = true
        else
          this.fileuploadgstMax = false

        if (file.size <= 0)
          this.fileuploadgstMin = true
        else
          this.fileuploadgstMin = false

        this.gstfileExtensionError = false;
        this.myfilegst.push(event.target.files[0])

      } else if (id == "fileuploadpoaz") {

        if (file.size > 4242880)
          this.fileuploadpoazMax = true
        else
          this.fileuploadpoazMax = false

        if (file.size <= 0)
          this.fileuploadpoazMin = true
        else
          this.fileuploadpoazMin = false

        this.poazfileExtensionError = false;
        this.myfilepoaz.push(event.target.files[0])
        this.entityForm.controls['fileuploadpoazid'].setValidators([Validators.required])
        this.entityForm.controls['fileuploadpoazid'].updateValueAndValidity()

      } else if (id == "fileuploadpoazid") {

        if (file.size > 4242880)
          this.fileuploadpoazidMax = true
        else
          this.fileuploadpoazidMax = false

        if (file.size <= 0)
          this.fileuploadpoazidMin = true
        else
          this.fileuploadpoazidMin = false

        this.poazidfileExtensionError = false;
        this.myfilepoazid.push(event.target.files[0])
        this.entityForm.controls['fileuploadpoaz'].setValidators([Validators.required])
        this.entityForm.controls['fileuploadpoaz'].updateValueAndValidity()


      }
      else if (id == "fileuploadother") {

        if (event.target.files.length > 2) {
          this.$modal.errorModal({
            title: 'Entity KYC Renewal',
            msg: 'More Than Two Files cannot be Uploaded!'
          })
          this.myfileother = [];
          this.entityForm.controls['fileuploadother'].reset();

          return;
        }
        // if (this.myfileotherDuplicate.length >= 2) {
        //   this.$modal.errorModal({
        //     title: 'Entity- Kyc -Renewal',
        //     msg: 'More Than Two Files cannot be Uploaded!'
        //   })
        // } else {
          if (file.size > 4242880)
            this.fileuploadotherMax = true
          if (file.size <= 0)
            this.fileuploadotherMin = true
          // this.myfileotherDuplicate.push(event.target.files[0])

          this.otherfileExtensionError = false;
          this.myfileother.push(event.target.files[0])
          if (event.target.files[1]) {
            this.myfileother.push(event.target.files[1])
            // this.myfileotherDuplicate.push(event.target.files[1])

          }
        // }
        this.entityForm.controls['fileuploadother'].reset();

      }
      else {
      }
    } else {
      if (id == "fileuploadpoi") {
        this.poifileExtensionError = true;

      } else if (id == "fileuploadpoa") {
        this.poafileExtensionError = true;

      } else if (id == "fileuploadsebi") {
        this.sebifileExtensionError = true;


      } else if (id == "fileuploadgst") {
        this.gstfileExtensionError = true;


      } else if (id == "fileuploadpoaz") {
        this.poazfileExtensionError = true;


      }
      else if (id == "fileuploadpoazid") {
        this.poazidfileExtensionError = true;


      }
      else if (id == "fileuploadother") {
        this.otherfileExtensionError = true;

      }
    }
  }


  changegstshow() {
    this.gstidinfo = this.entityForm.get("gstid").value;

    if (this.gstidinfo == "") {
      this.gstDoc = false
      this.entityForm.controls['confirmgstid'].setValue("")
      this.entityForm.controls['confirmgstid'].clearValidators()
      this.entityForm.controls['confirmgstid'].updateValueAndValidity()
      this.entityForm.controls['fileuploadgst'].clearValidators()
      this.entityForm.controls['fileuploadgst'].updateValueAndValidity()
    }
    else {
      this.gstDoc = true;
      this.entityForm.controls['fileuploadgst'].setValidators([Validators.required])
      this.entityForm.controls['fileuploadgst'].updateValueAndValidity()

      this.entityForm.controls['confirmgstid'].setValidators([Validators.required])
      this.entityForm.controls['confirmgstid'].updateValueAndValidity()
    }
  }


  focusOutFunction(address1) {

    if (address1.value === undefined || '') {
      return true;
    }
    var numbers = /^[0-9]+$/;
    let adrsValue = address1.value.match(numbers);
    if (address1.title === 'address1') {
      if (adrsValue) {
        this.isNumCheckadres1 = true;
      } else {
        this.isNumCheckadres1 = false;

      }
    }
    if (address1.title === 'address2') {
      if (adrsValue) {
        this.isNumCheckadres2 = true;
      } else {
        this.isNumCheckadres2 = false;
      }
    }
    if (address1.title === 'orgname') {
      if (adrsValue) {
        this.isNumOrgName = true;
      } else {
        this.isNumOrgName = false;
      }
    }


  };

  getvalidation() {
    this.entityForm.controls['address1'].setValue('');

    this.entityForm.controls['address1'].clearValidators();
    this.entityForm.controls['address1'].setValidators([Validators.nullValidator])
    this.entityForm.controls['address1'].updateValueAndValidity();

    this.entityForm.controls['address2'].setValue('');
    this.entityForm.controls['address2'].clearValidators();
    this.entityForm.controls['address2'].setValidators([Validators.nullValidator])
    this.entityForm.controls['address2'].updateValueAndValidity()

    this.entityForm.controls['selectedCountry'].reset();
    this.entityForm.controls['selectedCountry'].clearValidators();
    this.entityForm.controls['selectedCountry'].setValidators([Validators.nullValidator])
    this.entityForm.controls['selectedCountry'].updateValueAndValidity()

    this.entityForm.controls['selectedState'].reset();
    this.entityForm.controls['selectedState'].clearValidators();
    this.entityForm.controls['selectedState'].setValidators([Validators.nullValidator])
    this.entityForm.controls['selectedState'].updateValueAndValidity()
    this.entityForm.controls['selectedCity'].reset();

    this.entityForm.controls['selectedCity'].clearValidators();
    this.entityForm.controls['selectedCity'].setValidators([Validators.nullValidator])
    this.entityForm.controls['selectedCity'].updateValueAndValidity()

    this.entityForm.controls['pincode'].setValue('');
    this.entityForm.controls['pincode'].clearValidators();
    this.entityForm.controls['pincode'].setValidators([Validators.nullValidator])
    this.entityForm.controls['pincode'].updateValueAndValidity()

  }

  KYCyprocess() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '../../../../../assets/KYC Policy.pdf';
    link.download = 'Privacy KYC Policy Process';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  onSubmit() {
    //to verify the address change on submit and popup POA

    if ((this.addr1 != this.entityForm.get("address1").value) ||
      (this.addr2 != this.entityForm.get("address2").value) ||
      (this.landmk != this.entityForm.get("landmark").value) ||
      (this.country != this.entityForm.get("selectedCountry").value) ||
      (this.city != this.entityForm.get("selectedCity").value) ||
      (this.pincd != this.entityForm.get("pincode").value) ||
      (this.state != this.entityForm.get("selectedState").value)) {
      console.log(" iside setting true")
      this.docchanged = true

      //   this.$modal.successModal({
      // 	  title: 'Entity- Kyc -Renewal',
      // 	  msg: 'Note: Please upload the corresponding POA Document'
      //   })
    }
    console.log("this.docchanged  ******* ", this.docchanged)
    console.log("this.addr", this.addr1, this.addr2, this.landmk, this.country, this.city, this.pincd, this.state)
    console.log("after", this.entityForm.get("address1").value, this.entityForm.get("address2").value, this.entityForm.get("landmark").value, this.entityForm.get("selectedCountry").value, this.entityForm.get("selectedCity").value, this.entityForm.get("pincode").value, this.entityForm.get("selectedState").value)
    if (this.docchanged == false) {
      this.modalRef = this.modalService.show(ModalPromptEntityComponent)
      this.modalRef.content.modalDataObj = {
        title: "Entity KYC Renewal",
        msg: "1.Please check whether the details are same as per the Document Uploaded? 2.Please check if the corresponding KYC documents are uploaded as per the checklist.",
        btnYes: 'Yes',
        btnNo: 'No'
      }

    }
    else {
      this.modalRef = this.modalService.show(ModalPromptEntityComponent)
      this.modalRef.content.modalDataObj = {
        title: "Entity KYC Renewal",
        msg: "Have you uploaded the corresponding POA Document ?",
        btnYes: 'Yes',
        btnNo: 'No'
      }

    }
    this.modalRef.content.onClose.subscribe(result => {
      this.returnedValue = result

      if (this.returnedValue == true) {

        //enable fields
        this.entityForm.controls['industry_type'].enable()
        this.entityForm.controls['telemarket_sector'].enable()

        const entityForm: FormData = new FormData()
        //check user selected any classification
        entityForm.append('regEclass', "")
        if (this.selectedPE) {
          entityForm.append('regEclass', "PE")
          //this.selectedTM = true
        }
        else if (this.selectedTM) {
          entityForm.append('regEclass', "TM")
          //this.selectedPE = true 		
        }

        // if (this.selectedPE || this.selectedTM || this.selectedTA) {    
        // 	this.radiocheckshow = false
        // } else {
        // 	this.radiocheckshow = true
        // } 


        entityForm.append('industry_category', this.entityForm.get("industry_category").value)

        if (this.selectedPE) {
          entityForm.append('EClass_PE', "PE")
        }
        if (this.selectedTM) {
          entityForm.append('EClass_TM', "TM")
        }
        if (this.selectedTA) {
          entityForm.append('EClass_TA', "TA")
        }

        entityForm.append('TM_Type', this.entityForm.get("TM_Type").value)
        entityForm.append('Organization', this.entityForm.get("Organization").value)
        if (this.PANshow == true)
          entityForm.append('pantanno', this.entityForm.get("pantanno").value)
        else
          entityForm.append('pantanno', this.entityForm.get("tanno").value)
        entityForm.append('Entity_Ref_No', this.Entity_Ref_No)
        entityForm.append('entityId', this.entityId)
        entityForm.append('Common_ID', this.Common_ID)
        entityForm.append('email', this.entityForm.get("email").value)
        entityForm.append('mobileno', this.entityForm.get("mobileno").value)
        entityForm.append('authSignature', this.entityForm.get("auth_signature").value)
        entityForm.append('gstid', this.entityForm.get("gstid").value)
        entityForm.append('industry_type', this.entityForm.get("industry_type").value)
        entityForm.append('others_indType', this.entityForm.get("others_indType").value)
        entityForm.append('telemarket_sector', this.entityForm.get("telemarket_sector").value)
        entityForm.append('others_sector', this.entityForm.get("others_sector").value)

        //if(this.entityCreator == "tata") {
        entityForm.append('address1', this.entityForm.get("address1").value)
        entityForm.append('address2', this.entityForm.get("address2").value)
        if (this.entityForm.get("landmark").value)
          entityForm.append('landmark', this.entityForm.get("landmark").value)
        else
          entityForm.append('landmark', "")
        entityForm.append('selectedCountry', this.entityForm.get("selectedCountry").value)
        entityForm.append('selectedState', this.entityForm.get("selectedState").value)
        entityForm.append('selectedCity', this.entityForm.get("selectedCity").value)
        entityForm.append('pincode', this.entityForm.get("pincode").value)
        //}
        //  else {
        // 	entityForm.append('address1', "")
        // 	entityForm.append('address2', "")
        // 	entityForm.append('landmark', "")
        // 	entityForm.append('selectedCountry', "") 
        // 	entityForm.append('selectedState', "")
        // 	entityForm.append('selectedCity', "")
        // 	entityForm.append('pincode', "") 
        // }

        entityForm.append('selectpoi', this.entityForm.get("selectpoi").value)
        entityForm.append('selectpoa', this.entityForm.get("selectpoa").value)
        entityForm.append('otherdocname', this.entityForm.get("otherdocname").value)

        let entityAddress = ""
        if (this.entityCreator == "tata") {
          entityAddress = this.entityForm.get("address1").value + ", " + this.entityForm.get("address2").value + ", " + this.entityForm.get("landmark").value + ", " + this.entityForm.get("selectedCountry").value + ", " + this.entityForm.get("selectedState").value + ", " + this.entityForm.get("selectedCity").value + ", " + this.entityForm.get("pincode").value
          entityForm.append('entityCreator', "tata")
        } else {
          entityAddress = this.entityForm.get("dltAddress").value
          entityForm.append('entityCreator', this.entityCreator);
          //this.getvalidation();
        }
        entityForm.append('entityAddress', entityAddress)

        /*
        if(this.changeEmailMobile)  
          entityForm.append('entityStatus', "A")  
        else 
          entityForm.append('entityStatus', "C")
        */
        entityForm.append('entityStatus', "C")
        entityForm.append('Update_After_Approval', "N")	//update on page, if creator not tata always "M". If tata, "DM", "M"
        entityForm.append('Registered_Operator', this.Registered_Operator)
        entityForm.append('Registered_ID', this.Registered_ID)
        entityForm.append('reqtype', "postmodification") //for edit/audit logs  
        if (!this.gstDoc)
          entityForm.append('isGST', "NA")
        if (!this.isSEBI)
          entityForm.append('isSEBI', "NA")

        if (this.myfilepoi[0] != "" && this.myfilepoi[0] != undefined)
          entityForm.append('fileuploadpoi', this.myfilepoi[0])

        if (this.myfilepoa[0] != "" && this.myfilepoa[0] != undefined)
          entityForm.append('fileuploadpoa', this.myfilepoa[0])

        if (this.myfilegst[0] != "" && this.myfilegst[0] != undefined)
          entityForm.append('fileuploadgst', this.myfilegst[0])

        if (this.myfilesebi[0] != "" && this.myfilesebi[0] != undefined)
          entityForm.append('fileuploadsebi', this.myfilesebi[0])

        if (this.myfilepoaz[0] != "" && this.myfilepoaz[0] != undefined)
          entityForm.append('fileuploadpoaz', this.myfilepoaz[0])

        if (this.myfilepoazid[0] != "" && this.myfilepoazid[0] != undefined)
          entityForm.append('fileuploadpoazid', this.myfilepoazid[0])

        if (this.myfileother[0] != "" && this.myfileother[0] != undefined)
          entityForm.append('fileuploadother', this.myfileother[0])

        if (this.myfileother[1] != "" && this.myfileother[1] != undefined)
          entityForm.append('fileuploadother1', this.myfileother[1])

        if (!this.myfileother[0] && this.Entity_Other_Doc == "")
          entityForm.append('otherDoc', "empty")

        if (!this.myfileother[1] && this.Entity_Other_Doc1 == "")
          entityForm.append('otherDoc1', "empty")
        this.modifyOtherDetRemove = false;


        if (this.entityForm.invalid) {
          let invalid = [];
          let controls = this.entityForm.controls;
          for (const name in controls) {
            if (controls[name].invalid) {
              if (name == "fileuploadpoa") {
                this.$modal.successModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Please upload POA Document'
                })
              }
              else if (name == "fileuploadpoi") {
                this.$modal.successModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Please upload POI Document'
                })
              }
              else if (name == "fileuploadsebi") {
                this.$modal.successModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Please upload SEBI Document'
                })
              } else if (name == "fileuploadpoaz") {
                this.$modal.successModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Please upload Proof of Authorization Document'
                })
              }
              else if (name == "fileuploadpoazid") {
                this.$modal.successModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Please upload Identity Proof of Authorized Signatory Document'
                })
              }

              else if (name == "fileuploadgst") {
                this.$modal.successModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Please upload GST Document'
                })
              }
              invalid.push(name)
              console.log("Invalid kyc fields ---", invalid)
            }
          }
          return
        }
        else if (this.poifileExtensionError || this.poafileExtensionError || this.sebifileExtensionError || this.gstfileExtensionError || this.poazfileExtensionError || this.poazidfileExtensionError || this.otherfileExtensionError) {
           console.log("file extenstion error ---", this.poifileExtensionError , this.poafileExtensionError , this.sebifileExtensionError , this.gstfileExtensionError , this.poazfileExtensionError , this.poazidfileExtensionError , this.otherfileExtensionError)
          return;
        }
        else {
          console.log("Before Entity updation call")
          this.es.entityKycUpdation(entityForm)
            .subscribe(r => {
              if (r.status == "success") {
                this.$modal.successModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Request number pertaining to your entity renewal is ' + r.SR_URN + '. Login with your Entity ID to know the status through the link sent on your email ID.'
                })
                this.isDisabledbtn = true;
                // this.StatusCRegister=true;
                this.StatusCProfile = true;
                this.onPageLoad();

              }
              else {
                this.$modal.errorModal({
                  title: 'Entity KYC Renewal',
                  msg: 'Error updating Entity Details!'
                })
              }
            })
        }
      }
    })
  }
}
